// Mobile search bar toggle
let mobileSearchClickTarget = document.querySelector('.header-mobile-search');
let mobileSearchBar = document.querySelector('.header-mobile-search-bar');
let mobileSearchInput = mobileSearchBar.querySelector('input[type=search]');

if (mobileSearchClickTarget && mobileSearchBar) {
    var focusState = false;
    mobileSearchClickTarget.addEventListener('click', function () {
        document.body.classList.toggle('mobileSearchIsOpen');
        focusState = !focusState;
        if (focusState) {
            mobileSearchInput.focus();
        } else {
            mobileSearchInput.blur();
        }
    });
}

// Search bar : When bar is focused, add class to icon to let users know they are focused in on the search bar
let searchBar = document.querySelector('.header-search-bar');
if (searchBar) {
    let searchContainer = document.querySelector('.header-search-button');

    searchBar.addEventListener('focus', function () {
        searchContainer.classList.add('searchIsFocused');
    });
    searchBar.addEventListener('blur', function () {
        searchContainer.classList.remove('searchIsFocused');
    });
}